const OVERRIDES = {
    ocr: 'OCR',
    'post-ocr': 'Post-OCR',
    qa: 'QA',
    'pre-export': 'Pre-Export',
    'batch-fix': 'Batch Fix',
    'form-recognition': 'Form Recognition',
    'key-entry': 'Key Entry',
};
/**
 * C-19 (modal-redesign walkthrough 2026-05-11) — normalizes a kebab-case
 * stage identifier to operator-facing display copy.
 *
 * - Acronyms (OCR, QA) are uppercased
 * - Compound names (Batch Fix, Key Entry, Form Recognition) drop hyphens
 * - Hyphenated direction markers (Pre-Export, Post-OCR) keep their
 *   hyphens for readability
 * - Single words fall back to standard title-case
 *
 * Single source of truth for stage labels across StageSection,
 * PipelineTab, Rules tab, and any future stage UI.
 */
export function formatStageLabel(stage) {
    if (OVERRIDES[stage])
        return OVERRIDES[stage];
    return stage
        .split('-')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
}
//# sourceMappingURL=stage-labels.js.map